import { Box, Spacer } from '@jfs/ui-new'
import { FC } from 'react'
import { FlatList } from 'react-native'
import LinearGradient from 'react-native-linear-gradient'
import ShimmerPlaceHolder from 'react-native-shimmer-placeholder'

interface ShimmerViewProps {
  type: string
  itemCount?: number
}

const ShimmerView: FC<ShimmerViewProps> = ({ type, itemCount = 10 }: ShimmerViewProps) => {
  return (
    <>
      <FlatList
        data={new Array(itemCount).fill(0)}
        scrollEnabled={false}
        renderItem={() => <ShimmerViewItem type={type} itemCount={itemCount}/>}
        style={{ backgroundColor: 'white' }}
      />
    </>
  )
}

const ShimmerViewItem = ({ type }: ShimmerViewProps) => {
  return (
    <Box
      width="100%"
      flexDirection="row"
      borderBottomWidth={1}
      borderColor="GRAY_BORDER"
      paddingVertical="LARGE"
      paddingHorizontal="MEDIUM_BIG">
      <Box flex={1}>
        <ShimmerPlaceHolder LinearGradient={LinearGradient} visible={false} style={{ width: '50%', borderRadius: 24 }} />
        <Spacer size="SMALLEST" />
        <ShimmerPlaceHolder LinearGradient={LinearGradient} visible={false} style={{ width: '100%', borderRadius: 24 }} />
      </Box>

      <Box flex={1} />
      <Box>
        <ShimmerPlaceHolder LinearGradient={LinearGradient} visible={false} style={{ width: 100, borderRadius: 24 }} />
        <Spacer size="SMALLEST" />
        {type !== 'settelments' && (
          <ShimmerPlaceHolder LinearGradient={LinearGradient} visible={false} style={{ width: 100, borderRadius: 24 }} />
        )}
      </Box>
    </Box>
  )
}
export { ShimmerView }
